import { Component } from '@angular/core';
import { membersuiteWriteOffEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Write Offs') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitewriteoff-form',
    templateUrl: './membersuitewriteoff.form.component.html'
})
export class membersuiteWriteOffFormComponent extends BaseFormComponent {
    public record!: membersuiteWriteOffEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

